import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_DOMAIN = 'https://chemisalt.com';
const DEFAULT_IMAGE = `${DEFAULT_DOMAIN}/logo.webp`;
const DEFAULT_SITE_NAME = 'Chemi Salt Corporation';

const ROUTE_SEO = {
  '/': {
    title: 'Chemi Salt Corporation | Industrial Salts, Minerals & Chemicals Supplier in Vapi, Gujarat',
    description: 'Chemi Salt Corporation is a leading supplier of high-purity industrial salts, minerals, and chemicals in South Gujarat. Serving textile, food, paint, plastic, soap & chemical industries since 1980.',
    keywords: 'Chemi Salt Corporation, industrial salt supplier, minerals supplier, chemical supplier Vapi, sodium chloride, crystal salt, free flow salt, refined salt, South Gujarat',
    canonical: `${DEFAULT_DOMAIN}/`,
    ogTitle: 'Chemi Salt Corporation | Industrial Salts, Minerals & Chemicals Supplier',
    ogDescription: 'Chemi Salt Corporation is a trusted supplier of high-purity industrial salts, minerals, and chemicals in South Gujarat since 1980.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Chemi Salt Corporation | Industrial Salts, Minerals & Chemicals Supplier',
    twitterDescription: 'Chemi Salt Corporation is a trusted supplier of high-purity industrial salts, minerals, and chemicals in South Gujarat since 1980.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/aboutus': {
    title: 'About Us | Chemi Salt Corporation - Founded in 1980',
    description: 'Learn about Chemi Salt Corporation history, mission, vision, and core values. Trusted supplier of salts, minerals, and chemicals in South Gujarat for over 45 years.',
    keywords: 'About Chemi Salt, Pravin P Bhayani, Alpesh Bhayani, Trupesh Bhayani, chemical company Vapi Gujarat, company history, mission vision',
    canonical: `${DEFAULT_DOMAIN}/aboutus`,
    ogTitle: 'About Us | Chemi Salt Corporation',
    ogDescription: 'Founded in 1980, Chemi Salt Corporation is a trusted name in industrial salts, minerals, and chemicals across South Gujarat.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'About Us | Chemi Salt Corporation',
    twitterDescription: 'Founded in 1980, Chemi Salt Corporation is a trusted name in industrial salts, minerals, and chemicals across South Gujarat.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/products': {
    title: 'Our Products | Industrial Salts, Minerals & Chemicals - Chemi Salt Corporation',
    description: 'Explore Chemi Salt Corporation wide array of premium industrial products including refined salts, crystal salts, industrial minerals, and specialized chemical compounds.',
    keywords: 'industrial products, salts, minerals, industrial chemicals, salt supplier Vapi, raw materials Gujarat, Chemi Salt products',
    canonical: `${DEFAULT_DOMAIN}/products`,
    ogTitle: 'Our Products | Industrial Salts, Minerals & Chemicals - Chemi Salt',
    ogDescription: 'Explore Chemi Salt Corporation comprehensive product range: premium salts, high-grade minerals, and essential industrial chemicals.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Our Products | Industrial Salts, Minerals & Chemicals - Chemi Salt',
    twitterDescription: 'Explore Chemi Salt Corporation comprehensive product range: premium salts, high-grade minerals, and essential industrial chemicals.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/salts': {
    title: 'Industrial Salts | Refined, Crystal, Free Flow & Iodised Salt - Chemi Salt',
    description: 'High-purity industrial salt products including Refined Salt, Crystal Salt, Free Flow Salt, Fine Salt, 150 PPM & 50 PPM Salt, 40 Mesh Salt, and Iodised Salt by Chemi Salt.',
    keywords: 'Refined Salt, Crystal Salt, Free Flow Salt, Fine Salt, 150 PPM Salt, 40 Mesh Salt, Iodised Salt, industrial salt Vapi',
    canonical: `${DEFAULT_DOMAIN}/salts`,
    ogTitle: 'Industrial Salts | Refined, Crystal, Free Flow & Iodised Salt',
    ogDescription: 'High-purity industrial salt products tailored for textile, soap, chemical, food, and RO water treatment industries.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Industrial Salts | Refined, Crystal, Free Flow & Iodised Salt',
    twitterDescription: 'High-purity industrial salt products tailored for textile, soap, chemical, food, and RO water treatment industries.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/minerals': {
    title: 'Industrial Minerals | High Purity Mineral Solutions - Chemi Salt Corporation',
    description: 'Quality industrial minerals for manufacturing, agriculture, pharmaceuticals, and construction including Talc Powder, Dolomite, Calcite, China Clay, Silica, and Quartz Powder.',
    keywords: 'industrial minerals, Talc Powder, Dolomite, Calcite, China Clay, Silica, Quartz Powder, Hydrated Lime, Calcium Carbonate',
    canonical: `${DEFAULT_DOMAIN}/minerals`,
    ogTitle: 'Industrial Minerals | High Purity Mineral Solutions - Chemi Salt',
    ogDescription: 'Supplying high-quality industrial minerals precisely processed for plastics, paints, soap, adhesives, and construction.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Industrial Minerals | High Purity Mineral Solutions - Chemi Salt',
    twitterDescription: 'Supplying high-quality industrial minerals precisely processed for plastics, paints, soap, adhesives, and construction.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/chemicals': {
    title: 'Industrial Chemicals | Chemical Raw Materials & Solutions - Chemi Salt',
    description: 'Sourced and processed industrial chemicals ensuring safety, reliability, and purity for soap, textile, plastic, and chemical manufacturing in South Gujarat.',
    keywords: 'industrial chemicals, Soda Ash Light, Sulphur Black, Caustic Soda, PAC Powder, Sodium Sulphate, Aluminium Sulphate, Bleaching Powder, Citric Acid, Hydrogen Peroxide',
    canonical: `${DEFAULT_DOMAIN}/chemicals`,
    ogTitle: 'Industrial Chemicals | Raw Materials & Chemical Solutions - Chemi Salt',
    ogDescription: 'Comprehensive range of industrial chemicals for manufacturing, water treatment, textiles, and paper industries.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Industrial Chemicals | Raw Materials & Chemical Solutions - Chemi Salt',
    twitterDescription: 'Comprehensive range of industrial chemicals for manufacturing, water treatment, textiles, and paper industries.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/industriesWeServe': {
    title: 'Industries We Serve | Textile, Food, Paint, Plastic, Soap & Chemical - Chemi Salt',
    description: 'Chemi Salt Corporation caters to Textile, Food, Paint, Plastic, Chemical, and Soap manufacturing industries with tailored salt, mineral, and chemical solutions.',
    keywords: 'textile industry salt, food grade salt, paint chemicals, plastic industrial minerals, soap industry raw materials, industries served Vapi',
    canonical: `${DEFAULT_DOMAIN}/industriesWeServe`,
    ogTitle: 'Industries We Serve | Textile, Food, Paint, Plastic, Soap & Chemical',
    ogDescription: 'Trusted sourcing partner for Textile, Food Processing, Paints, Plastics, Soaps & Detergents, and Chemical manufacturing industries.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Industries We Serve | Textile, Food, Paint, Plastic, Soap & Chemical',
    twitterDescription: 'Trusted sourcing partner for Textile, Food Processing, Paints, Plastics, Soaps & Detergents, and Chemical manufacturing industries.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/contactus': {
    title: 'Contact Us | Chemi Salt Corporation - Vapi, Gujarat',
    description: 'Get in touch with Chemi Salt Corporation. Located at Dhanraj Nagar, Degam Rd, Vapi, Gujarat. Call +91 98247 44940 or email info@chemisalt.com.',
    keywords: 'contact Chemi Salt, Chemi Salt address Vapi, chemical supplier contact, phone email Chemi Salt',
    canonical: `${DEFAULT_DOMAIN}/contactus`,
    ogTitle: 'Contact Us | Chemi Salt Corporation - Vapi, Gujarat',
    ogDescription: 'Reach out to Chemi Salt Corporation for quotes, product inquiries, and industrial supply support.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Contact Us | Chemi Salt Corporation - Vapi, Gujarat',
    twitterDescription: 'Reach out to Chemi Salt Corporation for quotes, product inquiries, and industrial supply support.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  },
  '/sitemap': {
    title: 'Sitemap | Chemi Salt Corporation',
    description: 'View the complete sitemap of Chemi Salt Corporation to easily navigate through all pages, products, industries served, and contact details.',
    keywords: 'Chemi Salt sitemap, site navigation, page index, products sitemap, industries sitemap',
    canonical: `${DEFAULT_DOMAIN}/sitemap`,
    ogTitle: 'Sitemap | Chemi Salt Corporation',
    ogDescription: 'Complete visual sitemap and index of all pages and services on Chemi Salt Corporation website.',
    ogImage: DEFAULT_IMAGE,
    twitterTitle: 'Sitemap | Chemi Salt Corporation',
    twitterDescription: 'Complete visual sitemap and index of all pages and services on Chemi Salt Corporation website.',
    twitterImage: DEFAULT_IMAGE,
    robots: 'index, follow'
  }
};

const updateOrSetMeta = (attrKey, attrVal, content) => {
  if (!content) return;
  let element = document.head.querySelector(`meta[${attrKey}="${attrVal}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrKey, attrVal);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const updateOrSetCanonical = (href) => {
  if (!href) return;
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

export const useMetaTags = (customMeta = {}) => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const defaultConfig = ROUTE_SEO[currentPath] || ROUTE_SEO['/'];
    
    const config = {
      title: customMeta.title || defaultConfig.title,
      description: customMeta.description || defaultConfig.description,
      keywords: customMeta.keywords || defaultConfig.keywords,
      canonical: customMeta.canonical || defaultConfig.canonical,
      ogTitle: customMeta.ogTitle || defaultConfig.ogTitle,
      ogDescription: customMeta.ogDescription || defaultConfig.ogDescription,
      ogImage: customMeta.ogImage || defaultConfig.ogImage,
      ogUrl: customMeta.ogUrl || defaultConfig.canonical,
      twitterTitle: customMeta.twitterTitle || defaultConfig.twitterTitle,
      twitterDescription: customMeta.twitterDescription || defaultConfig.twitterDescription,
      twitterImage: customMeta.twitterImage || defaultConfig.twitterImage,
      robots: customMeta.robots || defaultConfig.robots || 'index, follow'
    };

    // Update Title
    document.title = config.title;

    // Update Standard Meta Tags
    updateOrSetMeta('name', 'description', config.description);
    updateOrSetMeta('name', 'keywords', config.keywords);
    updateOrSetMeta('name', 'robots', config.robots);
    updateOrSetMeta('name', 'author', 'Chemi Salt Corporation');

    // Update Canonical URL
    updateOrSetCanonical(config.canonical);

    // Update Open Graph Meta Tags
    updateOrSetMeta('property', 'og:type', 'website');
    updateOrSetMeta('property', 'og:site_name', DEFAULT_SITE_NAME);
    updateOrSetMeta('property', 'og:title', config.ogTitle);
    updateOrSetMeta('property', 'og:description', config.ogDescription);
    updateOrSetMeta('property', 'og:image', config.ogImage);
    updateOrSetMeta('property', 'og:url', config.ogUrl);

    // Update Twitter Card Meta Tags
    updateOrSetMeta('name', 'twitter:card', 'summary_large_image');
    updateOrSetMeta('name', 'twitter:title', config.twitterTitle);
    updateOrSetMeta('name', 'twitter:description', config.twitterDescription);
    updateOrSetMeta('name', 'twitter:image', config.twitterImage);
    updateOrSetMeta('name', 'twitter:url', config.ogUrl);

  }, [location.pathname, customMeta]);
};

export default useMetaTags;
